import styled from 'styled-components';

export const AirportPopupStyled = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 8px;
  padding: 16px;
`;

export const AirportPopupIataStyled = styled.div`
  line-height: 14px;
  color: ${({ theme }) => theme.kallisto.color.common.black[200]};
  font-size: 10px;
  font-weight: ${({ theme }) => theme.kallisto.font.weight.bold};
`;

export const AirportPopupNameStyled = styled.div`
  line-height: 20px;
  color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
  font-size: 14px;
  font-weight: ${({ theme }) => theme.kallisto.font.weight.bold};
  margin-bottom: 16px;
`;

export const AirportPopupSelectedStyled = styled.div`
  background: ${({ theme }) => theme.kallisto.color.common.black[50]};
  border-radius: 4px;
  height: 40px;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 8px;
  user-select: none;

  color: ${({ theme }) => theme.kallisto.color.common.black[200]};
`;

export const AirportPopupSelectedLabelStyled = styled.span`
  padding-left: 8px;
`;

export const AirportPopupNotSelectedStyled = styled.button`
  background-color: ${({ theme }) => theme.kallisto.color.background.static.backgroundBrandPrimary};
  border-radius: 4px;
  height: 40px;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 8px;
  user-select: none;
  border: 0;
  color: white;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: ${({ theme }) => theme.kallisto.color.background.interactive.backgroundPrimaryHover};
  }
`;

export const AirportPopupDescStyled = styled.div`
  line-height: 14px;
  color: ${({ theme }) => theme.kallisto.color.text.static.textSecondary};
  font-size: 10px;
  font-weight: ${({ theme }) => theme.kallisto.font.weight.regular};
`;
